import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CloseButton, EllipsisText, factory, Group, InputBase, useProps } from "@coveord/plasma-mantine";
import { IconChevronDown } from "@coveord/plasma-react-icons";
import { useTopBarContext } from "./TopBarContext.js";
var defaultProps = {};
export var TopBarSelect = factory(function(_props, ref) {
    var ctx = useTopBarContext();
    var _ref = useProps("TopBarSelect", defaultProps, _props), label = _ref.label, onClick = _ref.onClick, onClear = _ref.onClear, value = _ref.value, placeholder = _ref.placeholder, badge = _ref.badge, disabled = _ref.disabled, others = _object_without_properties(_ref, [
        "label",
        "onClick",
        "onClear",
        "value",
        "placeholder",
        "badge",
        "disabled"
    ]);
    var isClearable = !!onClear && !!value;
    return /*#__PURE__*/ _jsx(InputBase, _object_spread_props(_object_spread({
        rightSection: isClearable && !!value ? /*#__PURE__*/ _jsx(CloseButton, {
            "aria-label": "Clear ".concat(label),
            onClick: onClear,
            disabled: disabled
        }) : /*#__PURE__*/ _jsx(IconChevronDown, {
            height: 16
        }),
        component: "button",
        type: "button",
        pointer: true,
        disabled: disabled,
        rightSectionPointerEvents: isClearable ? "all" : "none",
        variant: "unstyled",
        onClick: onClick,
        label: label,
        ref: ref,
        classNames: {
            root: ctx.getStyles("select").className,
            wrapper: ctx.getStyles("selectWrapper").className,
            label: ctx.getStyles("selectLabel").className,
            input: ctx.getStyles("selectInput").className
        }
    }, others), {
        children: /*#__PURE__*/ _jsxs(Group, _object_spread_props(_object_spread({
            gap: "xs"
        }, ctx.getStyles("selectValue")), {
            wrap: "nowrap",
            children: [
                /*#__PURE__*/ _jsx(EllipsisText, {
                    maw: 325,
                    children: value !== null && value !== void 0 ? value : placeholder
                }),
                /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, ctx.getStyles("selectBadge")), {
                    children: badge
                }))
            ]
        }))
    }));
});
TopBarSelect.displayName = "TopBar.Select";

//# sourceMappingURL=TopBarSelect.js.map